import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDetailComponent } from '@components/notification-detail/notification-detail.component';
import { NotificationListComponent } from '@components/notification-list/notification-list.component';
import { GlobalNotification } from '@models/notifications/notification.model';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'gc-notification-floater',
  templateUrl: './notification-floater.component.html',
  styleUrls: ['./notification-floater.component.scss'],
  standalone: false,
})
export class NotificationFloaterComponent implements OnInit {
  notifications: GlobalNotification[] = [];
  notificationCount = 0;
  visible = false;
  isNotificationsActive = false;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications() {
    this.notificationService.getGlobalNotifications$().subscribe({
      next: (notifications) => {
        this.notifications = notifications;
        this.visible = notifications.length > 0;
        this.notificationCount = notifications.filter((n) => !n.read).length;
      },
    });
  }

  onFloaterClick() {
    this.isNotificationsActive = true;
    const dialogRef = this.dialog.open(NotificationListComponent, {
      data: { notifications: this.notifications },
      width: '400px',
      maxWidth: '95vw',
      maxHeight: '80vh',
    });

    dialogRef.componentInstance.openDetail.subscribe((notification: GlobalNotification) => {
      const notif = this.notifications.find((n) => n.uuid === notification.uuid);
      if (notif) {
        notif.read = true;
      }
      this.notificationCount = this.notifications.filter((n) => !n.read).length;
      dialogRef.close();
      this.openNotificationDetail(notification);
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isNotificationsActive = false;
    });
  }

  openNotificationDetail(notification: GlobalNotification) {
    const detailRef = this.dialog.open(NotificationDetailComponent, {
      data: notification,
      width: '400px',
      maxWidth: '95vw',
    });

    detailRef.afterClosed().subscribe(() => {
      this.onFloaterClick();
    });
  }
}
